// Utility to get caret coordinates (X, Y) in pixels inside a textarea or input.
// Ported from the popular caret-coordinates library to be dependency-free.

const properties = [
  'direction',
  'boxSizing',
  'width',
  'height',
  'overflowX',
  'overflowY',
  'borderWidth',
  'borderStyle',
  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'paddingLeft',
  'fontFamily',
  'fontSize',
  'fontWeight',
  'fontStyle',
  'fontVariant',
  'textTransform',
  'wordSpacing',
  'letterSpacing',
  'lineHeight',
  'textDecoration',
  'textAlign',
  'textIndent',
  'whiteSpace',
  'wordBreak',
  'wordWrap',
];

const isBrowser = typeof window !== 'undefined';
const isFirefox = isBrowser && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

export function getCaretCoordinates(element, position) {
  if (!isBrowser) return { top: 0, left: 0, height: 0 };

  // The mirror div will be positioned absolute, outside the screen
  const div = document.createElement('div');
  div.id = 'input-textarea-caret-position-mirror-div';
  document.body.appendChild(div);

  const style = div.style;
  const computed = window.getComputedStyle(element);

  // Line height standardizing
  style.position = 'absolute';
  style.visibility = 'hidden';
  style.whiteSpace = 'pre-wrap';
  style.wordWrap = 'break-word';

  // Copy all styling properties from the original element
  properties.forEach(prop => {
    style[prop] = computed[prop];
  });

  if (isFirefox) {
    // Firefox scrollbar width workaround
    if (element.scrollHeight > element.clientHeight) {
      style.overflowY = 'scroll';
    }
  } else {
    style.overflowY = 'hidden';
  }

  div.textContent = element.value.substring(0, position);

  const span = document.createElement('span');
  // Wrapping content to ensure it occupies space
  span.textContent = element.value.substring(position) || '.';
  div.appendChild(span);

  const coordinates = {
    top: span.offsetTop + parseInt(computed.borderTopWidth || 0),
    left: span.offsetLeft + parseInt(computed.borderLeftWidth || 0),
    height: parseInt(computed.lineHeight || computed.fontSize || 0),
  };

  document.body.removeChild(div);

  return coordinates;
}
